import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  input,
  output,
  viewChild
} from "@angular/core";
import { IconService } from "src/app/services/icon.service";

import { MatIcon } from "@angular/material/icon";
import { MatTooltip } from "@angular/material/tooltip";
import { ImageResolverPipe } from "../../../pipes/sharedpipes/image-resolver.pipe";

@Component({
  selector: "app-icon",
  templateUrl: "./icon.component.html",
  imports: [MatIcon, MatTooltip, ImageResolverPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconComponent implements OnInit {
  isInitialized = false;
  isSvg = false;
  isUrl = false;

  matTooltip = viewChild<MatTooltip>("tooltipId");

  icon = input<string | undefined>();
  class = input<string | undefined>();
  pointer = input(false);
  tooltip = input<string | undefined>();
  click$ = output<void>();

  constructor(public iconService: IconService) {}

  ngOnInit(): void {
    this.isSvg = this.iconService.IsSvgIcon(this.icon());
    this.isUrl = this.iconService.IsUrl(this.icon());
    this.isInitialized = true;
  }

  click(): void {
    if (this.tooltip()) this.matTooltip().toggle();
    if (this.click$) {
      // TODO: The 'emit' function requires a mandatory void argument
      this.click$.emit();
    }
  }

  handleTouchStart(): void {
    if (this.tooltip()) this.matTooltip().show();
  }
  handleTouchEnd(): void {
    if (this.tooltip()) this.matTooltip().hide();
  }
}
